var React = require('react');

function GlassMartiniAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M256 213.13L154.84 112h202.27z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M405.12 64L256 213.13 106.84 64h298.28m73.06-64H33.78C3.73 0-11.32 36.34 10 57.6l214 214V464h-56a40 40 0 0 0-40 40 8 8 0 0 0 8 8h240a8 8 0 0 0 8-8 40 40 0 0 0-40-40h-56V271.64l214-214C523.28 36.34 508.23 0 478.18 0z","className":"fa-primary","key":2})]);
}

GlassMartiniAlt.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = GlassMartiniAlt;

GlassMartiniAlt.default = GlassMartiniAlt;
